module.exports = __webpack_public_path__ + "static/img/5.b9223b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Responsabilidad-civil-danos-terceros/5.png
// module id = arn/
// module chunks = 0